import axios from 'axios';
import axiosInstance from '../../../_utils/axiosConfig';

let Restaurant : any = {};

Restaurant.submitForm = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/restaurant/add`, data,{
         headers: {
        'Content-Type': 'multipart/form-data'
       }
    })
}

Restaurant.verifyRestauForm = async (data:any)=>{
  return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/restaurant/verify`,data,{
      headers: {
        'Content-Type': 'multipart/form-data'
    }
  })
}

Restaurant.getHomeData = async (code:string) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/restaurant/home/${code}`)
}

Restaurant.getAllData = async (code:string) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/restaurant/all/${code}`)
}

Restaurant.submitReservation = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/restaurant/send/reservation`, data)
}

Restaurant.submitEdit = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/restaurant/edit`, data)
}

Restaurant.getOne = async (id:any) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/restaurant/show/${id}`)
}

Restaurant.getImages = async (id:any) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/restaurant/images/${id}`)
}

Restaurant.submitFormUp = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/restaurant/update/popUp/resto`, data)
}

Restaurant.saveComment = async(data:any)=>{
   return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/restaurant/save/comment`,data)
}

Restaurant.getAllComment = async(id:any)=>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/restaurant/get/all/${id}`);
}


export default Restaurant;